const actions = {
  ADD_DOCUMENTS: 'ADD_DOCUMENTS',
  ADD_DIMENSION: 'ADD_DIMENSION',
  CLEAR_ALL: 'CLEAR_ALL',

  add_documents: (docs) => {
    return (dispatch, getState) => {
      dispatch({
        type: actions.ADD_DOCUMENTS,
        value: docs,
      });
    };
  },

  add_dimension: (dim) => {
    return (dispatch, getState) => {
      dispatch({
        type: actions.ADD_DIMENSION,
        value: dim,
      });
    };
  },

  clear_all: () => {
    return (dispatch, getState) => {
      dispatch({
        type: actions.CLEAR_ALL,
      });
    };
  },
};
export default actions;
